import { render, staticRenderFns } from "./PackageTypes.vue?vue&type=template&id=90a75454"
import script from "./PackageTypes.vue?vue&type=script&lang=js"
export * from "./PackageTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports